import { useState, useEffect } from 'react';
import { User } from '@supabase/supabase-js';
import { supabase } from '../lib/supabase';

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      try {
        if (supabase?.auth) {
          // Real Supabase
          const {
            data: { session },
          } = await supabase.auth.getSession();
          setUser(session?.user ?? null);

          const {
            data: { subscription },
          } = supabase.auth.onAuthStateChange((_event, session) => {
            setUser(session?.user ?? null);
          });

          setLoading(false);
          return () => subscription?.unsubscribe();
        } else {
          // Mock auth - check localStorage
          const userData = localStorage.getItem('mock_user');
          const user = userData ? JSON.parse(userData) : null;
          setUser(user);
          setLoading(false);
        }
      } catch (error) {
        console.error('Auth initialization error:', error);
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  return { user, loading };
};
